import { Component, OnInit } from '@angular/core';
import { SidenavService } from '../../services/sidenav.service';
import { onMainContentChange } from '../../animations/animations';

@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.scss'],
  animations: [onMainContentChange]
})
export class DefaultComponent implements OnInit {
  public onSideNavChange: boolean;

  sideBarOpen = false;

  constructor(private _sidenavService: SidenavService) {
    this._sidenavService.sideNavState$.subscribe(res => {
      this.onSideNavChange = res;
    });
  }

  ngOnInit(): void {
    
  }

  sideBarToggler(e) {
    this.sideBarOpen = !this.sideBarOpen;
  }

}
